type InviteErrorContent = { title: string; description: string };

/** Keyed on the API's invite-check error messages, verbatim. */
const INVITE_ERROR_CONTENT: Record<string, InviteErrorContent> = {
  'Invalid or expired invitation invitation': {
    title: 'Link has expired',
    description: 'The invitation link is invalid or has expired.',
  },
  'You have already accepted the invitation': {
    title: 'Invitation already accepted',
    description: 'You have already accepted this invitation. Please log in to your account.',
  },
  'You have been suspended': {
    title: 'You have been suspended',
    description: 'Your access has been suspended. Please contact support for more information.',
  },
  'Cannot sign up': {
    title: 'Account not set up',
    description:
      'We could not find an account to add this invitation to. Reload this page to create one, or contact support if this keeps happening.',
  },
  'You are set to inactive': {
    title: 'Your account is inactive',
    description: 'Your account is currently inactive. Please contact support for more information.',
  },
};

const DEFAULT_INVITE_ERROR: InviteErrorContent = {
  title: 'Invalid invitation',
  description: 'There was an issue with your invitation. Please contact support for assistance.',
};

export const getInviteErrorContent = (errorMessage: string): InviteErrorContent =>
  INVITE_ERROR_CONTENT[errorMessage] ?? DEFAULT_INVITE_ERROR;

/** Unwraps either an API error envelope (`{ error: { message } }`) or a thrown `Error`. */
export const toInviteErrorMessage = (error: unknown): string => {
  if (
    typeof error === 'object' &&
    error !== null &&
    'error' in error &&
    typeof (error as { error?: { message?: unknown } }).error?.message === 'string'
  ) {
    return (error as { error: { message: string } }).error.message;
  }

  return error instanceof Error ? error.message : 'Invalid invitation';
};

/** A known refusal's description, else the server's own message, else `fallback`. */
export const describeInviteFailure = (error: unknown, fallback: string): string => {
  const message = toInviteErrorMessage(error);
  return INVITE_ERROR_CONTENT[message]?.description ?? (message || fallback);
};
